var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArionStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 67,
    width: 66,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 66 67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    fillRule: "evenodd",
    d: "M 16.09 50.91 L 16.09 35.09 C 16.09 35.05 16.06 35.02 16.03 35.01 C 16 34.99 15.96 35 15.93 35.03 L 0.03 50.94 C 0 50.96 -0.01 51 0.01 51.03 C 0.02 51.07 0.05 51.09 0.09 51.09 L 15.9 51.09 L 15.9 66.91 C 15.9 66.95 15.93 66.98 15.96 66.99 C 15.97 67 15.98 67 16 67 C 16.02 67 16.04 66.99 16.06 66.97 L 31.97 51.06 C 32 51.04 32.01 51 31.99 50.97 C 31.98 50.93 31.95 50.91 31.91 50.91 L 16.09 50.91 Z M 16.09 50.91"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    fillRule: "evenodd",
    d: "M 15.93 31.97 C 15.95 31.99 15.97 32 16 32 C 16.01 32 16.02 32 16.03 31.99 C 16.06 31.98 16.09 31.95 16.09 31.91 L 16.09 16.09 L 31.91 16.09 C 31.95 16.09 31.98 16.07 31.99 16.03 C 32.01 16 32 15.96 31.97 15.93 L 16.06 0.03 C 16.03 0 15.99 -0.01 15.96 0.01 C 15.93 0.02 15.9 0.05 15.9 0.09 L 15.9 15.91 L 0.09 15.91 C 0.05 15.91 0.02 15.93 0.01 15.96 C -0.01 16 0 16.04 0.03 16.06 L 15.93 31.97 Z M 15.93 31.97"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    fillRule: "evenodd",
    d: "M 49.91 16.09 L 49.89 31.91 C 49.89 31.95 49.91 31.98 49.95 31.99 C 49.96 32 49.97 32 49.98 32 C 50.01 32 50.03 31.99 50.05 31.97 L 65.97 16.06 C 66 16.03 66.01 16 65.99 15.96 C 65.98 15.93 65.95 15.91 65.91 15.91 L 50.09 15.91 L 50.08 0.09 C 50.08 0.05 50.05 0.02 50.02 0.01 C 49.98 -0.01 49.94 0 49.92 0.03 L 34.03 15.93 C 34 15.96 33.99 16 34.01 16.03 C 34.02 16.06 34.05 16.09 34.09 16.09 L 49.91 16.09 Z M 49.91 16.09"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    fillRule: "evenodd",
    d: "M 48.97 32.94 L 33.06 17.03 C 33.02 16.99 32.96 16.99 32.93 17.03 L 17.03 32.94 C 16.99 32.97 16.99 33.03 17.03 33.06 L 32.93 48.97 C 32.95 48.99 32.97 49 32.99 49 C 33.02 49 33.04 48.99 33.06 48.97 L 48.97 33.06 C 49.01 33.03 49.01 32.97 48.97 32.94"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    fillRule: "evenodd",
    d: "M 50.05 35.03 C 50.02 35 49.98 34.99 49.95 35.01 C 49.92 35.02 49.89 35.05 49.89 35.09 L 49.91 50.91 L 34.09 50.91 C 34.05 50.91 34.02 50.93 34.01 50.96 C 33.99 51 34 51.04 34.03 51.06 L 49.93 66.97 C 49.95 66.99 49.97 67 50 67 C 50.01 67 50.02 67 50.03 66.99 C 50.07 66.98 50.09 66.95 50.09 66.91 L 50.09 51.09 L 65.91 51.09 C 65.95 51.09 65.98 51.07 65.99 51.03 C 66.01 51 66 50.96 65.97 50.93 L 50.05 35.03 Z M 50.05 35.03"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArionStar);
export default __webpack_public_path__ + "static/media/arion-star.fd7334d1a950175ce8a0fe6bf3559da6.svg";
export { ForwardRef as ReactComponent };